import { Teaching } from './store';

export const formatTeachingContent = (teaching: Teaching): string => {
  const timestamp = teaching.timestamp instanceof Date 
    ? teaching.timestamp.toLocaleString()
    : new Date(teaching.timestamp).toLocaleString();

  return `# Teaching Session - ${timestamp}

## Content
${teaching.content}

## Formatted Teaching
${teaching.summary}

${teaching.aiResponses?.length ? `
## AI Interactions
${teaching.aiResponses.join('\n\n')}` : ''}
`;
};

export const downloadAsFile = (content: string, filename: string, type: 'txt' | 'md' | 'html') => {
  let fileContent = content;
  let mimeType = 'text/plain';
  
  if (type === 'html') {
    fileContent = `<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <title>${filename}</title>
  <style>
    body { font-family: system-ui, -apple-system, sans-serif; max-width: 800px; margin: 2rem auto; padding: 0 1rem; }
    h1, h2 { color: #f59e0b; }
    pre { background: #f3f4f6; padding: 1rem; border-radius: 0.5rem; }
  </style>
</head>
<body>
  ${content.split('\n').map(line => {
    if (line.startsWith('# ')) return `<h1>${line.slice(2)}</h1>`;
    if (line.startsWith('## ')) return `<h2>${line.slice(3)}</h2>`;
    return `<p>${line}</p>`;
  }).join('\n')}
</body>
</html>`;
    mimeType = 'text/html';
  } else if (type === 'md') {
    mimeType = 'text/markdown';
  }

  const blob = new Blob([fileContent], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${filename}.${type}`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};